export const select_device_map = (state, device_id) => {
    if (device_id) {
        return state.map.items[device_id];
    }
    return null;
};
export const select_provider_config = (state) => {
    return state.map.providers_config;
};
export const select_map_center_per_device = (state) => {
    return Object.fromEntries(Object.entries(state.map.items).map(([device_id, map_state]) => [
        device_id,
        map_state.center,
    ]));
};
